import {z} from 'zod';

import {BaseVoidResponseSchema} from '@dms/api/shared';

export const CustomerServiceContractRequestBodySchema = z.object({
  number: z.string(),
  validFrom: z.string().nullish(),
  validTo: z.string().nullish(),
  authorizationProfileIds: z.array(z.string()),
  value: z.number().nullish(),
  note: z.string().nullish(),
});

export const GetCustomerServiceContractApiResponseSchema = z.object({
  serviceContractId: z.string(),
  customerId: z.string(),
  number: z.string(),
  validFrom: z.string().nullish(),
  validTo: z.string().nullish(),
  authorizationProfileIds: z.array(z.string()),
  value: z.number().nullish(),
  remainingValue: z.number(),
  note: z.string().nullish(),
});

export const GetCustomerServiceContractApiArgSchema = z.object({
  customerId: z.string(),
  serviceContractId: z.string(),
});

export type GetCustomerServiceContractResponse = z.infer<
  typeof GetCustomerServiceContractApiResponseSchema
>;

export type GetCustomerServiceContractArg = z.infer<typeof GetCustomerServiceContractApiArgSchema>;

export const DeleteCustomerServiceContractApiArgSchema = z.object({
  customerId: z.string(),
  serviceContractId: z.string(),
});

export const DeleteCustomerServiceContractApiResponseSchema = BaseVoidResponseSchema;

export type DeleteCustomerServiceContractResponse = z.infer<
  typeof DeleteCustomerServiceContractApiResponseSchema
>;

export type DeleteCustomerServiceContractArg = z.infer<
  typeof DeleteCustomerServiceContractApiArgSchema
>;

export type CustomerServiceContractRequestBody = z.infer<
  typeof CustomerServiceContractRequestBodySchema
>;

export const PatchCustomerServiceContractApiArgSchema = z.object({
  customerId: z.string(),
  serviceContractId: z.string(),
  body: CustomerServiceContractRequestBodySchema.nullable(),
});

export const PatchCustomerServiceContractApiResponseSchema = BaseVoidResponseSchema;

export type PatchCustomerServiceContractResponse = z.infer<
  typeof PatchCustomerServiceContractApiResponseSchema
>;

export type PatchCustomerServiceContractArg = z.infer<
  typeof PatchCustomerServiceContractApiArgSchema
>;

export const PostCustomerServiceContractApiResponseSchema = z
  .object({
    serviceContractId: z.string(),
  })
  .nullable();

export type PostCustomerServiceContractResponse = z.infer<
  typeof PostCustomerServiceContractApiResponseSchema
>;

export type PostCustomerServiceContractArg = z.infer<
  typeof PostCustomerServiceContractApiArgSchema
>;

export const PostCustomerServiceContractApiArgSchema = z.object({
  customerId: z.string(),
  body: CustomerServiceContractRequestBodySchema.nullable(),
});

export const GetServiceContractsApiArgSchema = z.object({
  customerId: z.string(),
  authorizationProfileId: z.string().nullish(),
  onlyValid: z.boolean().nullish(),
});

export const GetServiceContractsApiResponseSchema = z.array(
  GetCustomerServiceContractApiResponseSchema
);

export type GetServiceContractsArg = z.infer<typeof GetServiceContractsApiArgSchema>;
export type GetServiceContractsResponse = z.infer<typeof GetServiceContractsApiResponseSchema>;
